import { createStyles, Theme } from '@material-ui/core';

const styles = ({
  custom: {
    palette: { colorSupportPowder, colorSupportSnow, colorSupportSteel, colorLightBlue },
  },
  palette: {
    secondary,
    text,
    common: { white, black },
  },
  spacing: { unit },
}: Theme) =>
  createStyles({
    root: {
      backgroundColor: colorSupportSnow,
      display: 'flex',
      flexDirection: 'column',
      width: '100%',
      height: '100%',
    },
    rootHidden: {
      // WORKAROUND fix style issues on filters by forcing other stuff being hidden
      // We want to continue rendering other stuff to keep the local state
      // TODO cleanup styles once we move filters to V2
      visibility: 'hidden',
      width: 0,
    },
    emptyMessage: {
      borderTop: '1px solid rgba(0, 0, 0, 0.25)',
      display: 'inline-block',
      height: '80%',
      marginTop: 0,
      padding: `${unit * 3}px ${unit * 3 + 4}px`,
      width: '100%',
      '&$filtering': {
        marginTop: `${unit * 2}px`,
      },
    },
    filtering: {},
    filterButton: {
      marginRight: unit * 3,
      backgroundColor: white,
      border: `1px solid ${colorLightBlue}`,
      minWidth: 0,
      padding: `0 ${unit * 1.5}px`,
    },
    filterButtonOn: {
      marginRight: unit * 3,
      minWidth: 0,
      backgroundColor: colorSupportPowder,
      border: `1px solid ${colorLightBlue}`,
      padding: `0 ${unit * 1.5}px`,
    },
    orangeDot: {
      backgroundColor: secondary.main,
      borderRadius: '50%',
      display: 'inline-block',
      height: 6,
      width: 6,
      marginLeft: unit / 2,
      position: 'absolute',
      top: 9,
      right: 5,
    },
    listContent: {
      backgroundColor: white,
      display: 'inline-block',
      float: 'left',
      marginTop: 0,
      padding: 0,
      width: '100%',
      '&$filtering': {
        marginTop: `${unit * 2}px !important`,
      },
    },
    listWrapper: {
      display: 'flex',
      flex: 1,
      flexDirection: 'column',
      overflow: 'auto',
    },
    loading: {
      borderTop: '1px solid rgba(0, 0, 0, 0.25)',
      display: 'inline-block',
      marginTop: 0,
      padding: '30%',
      textAlign: 'center',
      width: '100%',
      '&$filtering': {
        marginTop: `${unit * 2}px !important`,
      },
    },
    title: {
      backgroundColor: colorSupportSnow,
      float: 'left',
      padding: `${unit * 2}px ${unit * 3}px ${unit}px ${unit * 3}px`,
      width: '100%',
    },
    searchWrapper: {
      display: 'flex',
      flexDirection: 'column',
      marginTop: unit * 2,
      marginBottom: unit * 2,
    },
    searchItems: {
      display: 'flex',
      marginLeft: unit * 3,
      marginRight: unit * 3,
    },
    btnClearPadding: {
      padding: `0 ${unit}px`,
    },
    filteredResultOnText: {
      display: 'flex',
      alignItems: 'center',
      padding: `${unit}px ${unit * 3}px`,
      fontWeight: 600,
    },
    addPatientLinkWrapper: {
      marginTop: unit,
      padding: `${unit}px ${unit * 3}px 0px ${unit * 3}px`,
    },
    linkStyle: {
      cursor: 'pointer',
      fontSize: 15,
      fontWeight: 500,
      color: black,
      textDecoration: 'underline',
      textDecorationColor: colorSupportSteel,
    },
    closeChatWrapper: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      backgroundColor: white,
      padding: unit,
    },
    checkboxWrapper: {
      display: 'flex',
      alignItems: 'center',
      backgroundColor: white,
    },
    checkbox: {
      color: colorSupportSteel,
      padding: 0,
      height: 16,
      width: 16,
      marginRight: unit,
      marginLeft: unit - 3,
    },
    checkboxLabel: {
      color: text.secondary,
      fontSize: 12,
    },
    checkboxLabelSelected: {
      color: black,
      fontSize: 12,
      fontWeight: 500,
    },
    closeChatText: {
      cursor: 'pointer',
      color: black,
      textDecoration: 'underline',
      fontSize: 12,
      fontWeight: 500,
      marginRight: unit * 2,
    },
  });

export default styles;
